// Local translations
export const T = {
  en_GB: {
    noCostTypesConfigured: "No cost types configured for this collection.",
    costDataFromLinked: "Cost data from linked instrument",
    noInstrumentLinked: "No instrument linked. Add costs and enter override values manually.",
    fetchLatestCosts: "Fetch Latest Costs",
    loadingApiData: "Loading API data...",
    failedToFetchCostData: "Failed to fetch cost data",
    costType: "Cost Type",
    category: "Category",
    calculatedValue: "Calculated Value",
    overriddenValue: "Overridden Value",
    helpTextLinked:
      "Click 'Fetch Latest Costs' to refresh calculated values for assigned costs. Click 'Add' on any unassigned row to attach it — values are pulled from the linked instrument when available.",
    helpTextManual:
      "No instrument is linked. Click 'Add' on any unassigned row and enter its value manually.",
    categoryRecurring: "Recurring",
    categoryDeposit: "Deposit",
    categoryWithdrawal: "Withdrawal",
    add: "Add",
    remove: "Remove",
    overrideMustBeNonNegative: "Overridden value must be 0 or greater",
  },
  nb_NO: {
    noCostTypesConfigured: "Ingen kostnadstyper konfigurert for denne samlingen.",
    costDataFromLinked: "Kostnadsdata fra koblet instrument",
    noInstrumentLinked:
      "Ingen instrument koblet. Legg til kostnader og angi overstyrte verdier manuelt.",
    fetchLatestCosts: "Hent siste kostnader",
    loadingApiData: "Laster API-data...",
    failedToFetchCostData: "Kunne ikke hente kostnadsdata",
    costType: "Kostnadstype",
    category: "Kategori",
    calculatedValue: "Beregnet verdi",
    overriddenValue: "Overstyrt verdi",
    helpTextLinked:
      "Klikk 'Hent siste kostnader' for å oppdatere beregnede verdier for tilordnede kostnader. Klikk 'Legg til' på en ikke-tilordnet rad for å knytte den til — verdier hentes fra det koblede instrumentet når de er tilgjengelige.",
    helpTextManual:
      "Ingen instrument er koblet. Klikk 'Legg til' på en ikke-tilordnet rad og angi verdien manuelt.",
    categoryRecurring: "Løpende",
    categoryDeposit: "Innskudd",
    categoryWithdrawal: "Uttak",
    add: "Legg til",
    remove: "Fjern",
    overrideMustBeNonNegative: "Overstyrt verdi må være 0 eller større",
  },
} as const;
